import React, { useState, useEffect, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import { testimonialsSectionStyles } from './TestimonialsSection.styles';
import TestimonialCard from './TestimonialCard/TestimonialCard';
import { dummyTestimonials } from './TestimonialsSection.constants';

const TestimonialsSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef(null);
  const cardPositions = [
    testimonialsSectionStyles.card1,
    testimonialsSectionStyles.card2,
    testimonialsSectionStyles.card5,
    testimonialsSectionStyles.card3,
    testimonialsSectionStyles.card4,
    testimonialsSectionStyles.card6,
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    const currentRef = containerRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <Box ref={containerRef} sx={testimonialsSectionStyles.container}>
      <Typography
        sx={testimonialsSectionStyles.heading}
      >
        what our
        <br />
        clients say?
      </Typography>
      <Box sx={testimonialsSectionStyles.cardsContainer}>
      {dummyTestimonials.map((testimonial, index) => (
        <Box
          key={index}
          sx={{
            ...cardPositions[index],
            ...testimonialsSectionStyles.fadeIn(isVisible, index * 0.15, index),
          }}
        >
          <TestimonialCard {...testimonial} />
        </Box>
      ))}
      </Box>
     
    </Box>
  );
};

export default TestimonialsSection;

